import { SectionType } from '@modules/section/enums/section-type.enum';
import { InfoVariant } from '@modules/ui/info/info.component';
import { z } from 'zod';

import { QAFormSchema } from './qaform.adapter';

type APIInfoTheme = 'PRIMARY' | 'INFO' | 'DANGER' | 'SUCCESS' | 'WARNING';
const mapInfoType = (type: APIInfoTheme | string): InfoVariant => {
  return type.toLowerCase() as InfoVariant;
};

const InfoSectionSchema = z
  .object({
    id: z.string().uuid(),
    anchor_link: z.string().nullable(),
    info_type: z.enum(['PRIMARY', 'INFO', 'DANGER', 'SUCCESS', 'WARNING']),
    button_target_type: z.enum(['blank', 'self', 'modal']),
    title: z.string().nullable(),
    text: z.string().nullable(),
    button_link: z
      .object({
        title: z.string(),
        uri: z.string().url(),
      })
      .nullable(),
    qa_form: QAFormSchema.nullable(),
  })
  .transform((data) => ({
    type: SectionType.INFO,
    customHeadline: true,
    anchor: data.anchor_link,
    title: data.title,
    text: data.text,
    infoType: mapInfoType(data.info_type),
    buttonTargetType: data.button_target_type,
    buttonLabel: data.button_link?.title,
    buttonLink: data.button_link?.uri,
    qaForm: data.qa_form,
  }));

export type LinkTarget = 'blank' | 'self' | 'modal';

export class InfoSectionAdapter {
  public static parse(data: any) {
    const result = InfoSectionSchema.safeParse(data);
    if (result.success) {
      return result.data;
    } else {
      throw result.error;
    }
  }
}
